export default () => ({
  context: {
    auth: {
      clientId: '',
    },
  },
  user: null,
  guest: null,
  error: null,
  token: null,
  isInitializing: false,
  initialized: false,
  savedVehicleIds: [],
  isGotSavedVahicleIds: false,
  isSavedVehiclesLoading: false,
  policyContent: '',
});
